import React from "react";
import "./OurPrinciples.css";
import Wave from "../../../../assets/images/assistance-wave.png";
import Star from "../../../../assets/icons/assistance-star.svg";
import Card1 from "../../../../Components/Cards/Card1";
import Accuracy from "../../../../assets/images/assistance-accuracy.png";
import Headphone from "../../../../assets/images/assistance-headphone.png";
import Person from "../../../../assets/images/assistance-person.png";
import CardImg1 from "../../../../assets/images/ourprinciples-card1.png";
import CardImg2 from "../../../../assets/images/ourprinciples-card2.png";
import CardImg3 from "../../../../assets/images/ourprinciples-card3.png";
const OurPrinciples = () => {
  return (
    <div className="ourprinciples__section">
      <img src={Wave} className="ourprinciples__section_wave" />
      <div className="ourprinciples__section_heading">
        <span className="ourprinciples__section_headingblack">Our</span>{" "}
        <span className="ourprinciples__section_headinggreen">Principles</span>
        <p className="ourprinciples__section_desc">
          we guide our clients through a full range of tax planning and
          preparation decisions with strategies that minimize your tax
          liabilities
        </p>
        <div className="ourprinciples__section_cards">
          <div className="ourprinciples__section_card">
            <Card1
              image={CardImg1}
              dotColor="transparent"
              backgroundColor="gba(0, 142, 255, 0.15)"
              heading="We bring order to chaos"
              description="We treat our clients as partners who need help in resolving any issues or filing tax the right way. We are here to shine a light on your problems and bring peace of mind in the toughest of situations."
            />
          </div>
          <div className="ourprinciples__section_card">
            <Card1
              image={CardImg2}
              dotColor="rgba(156, 225, 155, 1) "
              backgroundColor="rgba(20, 176, 130, 0.15)"
              heading="We do it right the first time"
              description="Our team has the right technical expertise to crack solutions every time and help clients to ease through the process. Our team follows the motto “ there is no room for mistakes”. "
            />
          </div>
          <div className="ourprinciples__section_card">
            <Card1
              image={CardImg3}
              dotColor="rgba(122, 183, 255, 1)"
              backgroundColor="rgba(122, 67, 238, 0.1)"
              heading="You need it? We provide it."
              description="At Executive Tax and Accounting Services, there are no excuses. If you need a service provided, we will find a way to complete it. Our paperwork is accurate and always up to date"
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default OurPrinciples;
